import React from 'react';
import DefaultPanel from "../classes/DefaultPanel";
import Icon16Clear from '@vkontakte/icons/dist/16/clear';


export default class PanelWrongUser extends DefaultPanel {

	settings() {
		this.title = 'Авторизация';
		this.theme = 'gray';
	}

	renderPanel() {
		return(
			<div className="access-deny">
				<div className="icon-deny"><Icon16Clear/></div>
				<div>Доступ запрещен</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/js/panels/PanelWrongUser.js